jQuery(document).ready(function ($){
    'use strict';

    $(document).on('click', '.load-more-news', function(e) {
        e.preventDefault();

        let $button = $(this);
        let $post_id = $button.data('id');
        let $container = $('.news-items');
        let $items = $('.news-item').length;
        let $posts_per_page = $items + $button.data('posts_per_page');
        let $excluded_posts = $('.news-item')
            .map(function() {
                return $(this).data('id');
            })
            .get();
        let fd = new FormData();

        fd.append('post_id', $post_id );
        fd.append('posts_per_page', $posts_per_page );
        fd.append('excluded_posts', $excluded_posts );

        if ( $button.hasClass('load-more-district-news') ) {
            fd.append('action', 'load_more_district_news');
        } else {
            fd.append('action', 'load_more_department_news');
        }


        $.ajax({
            type: 'POST',
            url: '/wp-admin/admin-ajax.php',
            data: fd,
            contentType: false,
            processData: false,
            beforeSend: function(data) {
                $button.addClass('loading');
            },
            success: function(data) {
                $button.removeClass('loading');
                $container.append(data);

                setTimeout(function() {
                    if( $('.empty-news-results').length ) {
                        $button.remove();
                    }
                }, 50);
            },
            error: function(data) {
                $button.removeClass('loading');
            },
        });

    });
});